import { AxiosResponse } from "axios";
import BaseApi from "./BaseApi";
import AxiosService from "./Axios";

const BASE_URL = '/tenant-feature';

class TenantFeatureApi {

    public async getMetas(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/metas');
    }

    public async getTenantFeatures(tenantId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/tenant-features', {
            params: { tenantId: tenantId }
        });
    }

    public async setTenantFeatures(tenantId: string, tenantFeatures: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/set-tenant-features', {
            tenantId: tenantId,
            featureCodePaths: tenantFeatures
        });
    }
}

export default TenantFeatureApi;

